import { render } from "./_LinkedCompany.vue?vue&type=template&id=21883496"
import script from "./_LinkedCompany.vue?vue&type=script&lang=js"
export * from "./_LinkedCompany.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__